let FJComponentUtil = {
    getElementViewSize: function (view) {
        if (view) {
            return {
                width: view.offsetWidth,
                height: view.offsetHeight,
            };
        }
        return null;
    },
    getElementView: function (viewKey) {
        // 根据 viewKey 获取对应的 DOM 元素
        // 当前项目中未实际使用，但 FJSprite.js 中有调用，保留空实现避免报错
        return null;
    },
};

export default FJComponentUtil;
